import React from "react";
import * as Styled from "./styles";
import { ReturnButton } from "components/ReturnButton";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";
import { IoCheckmark } from "react-icons/io5";

interface IProps {
  title: string | (string | boolean)[];
  children: React.ReactNode;
}

const HeadConsult: React.FC<IProps> = ({ title, children }) => {
  const { step, editMode, patientObj } = useClinicalBudget();

  const displayTitle = Array.isArray(title) 
    ? title.find(t => t !== false) 
    : title;

  return (
    <Styled.Container>
      <ReturnButton
        title={editMode ? "Editar Orçamento" : "Orçamento Clínico"}
        subtitle={patientObj?.pac_name || ""}
      />
      
      <Styled.StepIndicator>
        <Styled.StepDot active={step === 1} completed={step > 1}>
          {step > 1 ? <IoCheckmark size={16} /> : '1'}
        </Styled.StepDot>
        <Styled.StepLine completed={step > 1} />
        <Styled.StepDot active={step === 2} completed={step > 2}>
          {step > 2 ? <IoCheckmark size={16} /> : '2'}
        </Styled.StepDot>
        <Styled.StepLine completed={step > 2} />
        <Styled.StepDot active={step === 3} completed={step > 3}>
          {step > 3 ? <IoCheckmark size={16} /> : '3'}
        </Styled.StepDot>
      </Styled.StepIndicator>

      <Styled.Title>{displayTitle}</Styled.Title>

      {children}
    </Styled.Container>
  );
};

export { HeadConsult };

